export default "__VITE_ASSET__BjzXbH5j__"